<template>
  <div class="flex flex-col gap-4 mb-2">
    <div
      class="flex flex-col p-4 border border-solid border-slate-75 dark:border-slate-700 overflow-hidden rounded-md flex-grow shadow-sm bg-gray-50 dark:bg-slate-900 text-slate-700 dark:text-slate-100"
    >
      <woot-message-editor
        v-model="noteContent"
        class="input--note"
        :placeholder="$t('NOTES.ADD.PLACEHOLDER')"
        :enable-suggestions="false"
      />
    </div>
    <div class="flex justify-end w-full">
      <button-v2
        variant="filled"
        size="lg"
        :title="$t('NOTES.ADD.TITLE')"
        :disabled="buttonDisabled"
        @click="onAdd"
      >
        <template #icon>
          <v2-icon icon="note" :size="24" />
        </template>
        {{ $t('NOTES.ADD.SUBMIT') }}
      </button-v2>
    </div>
  </div>
</template>

<script>
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';
import V2Icon from 'v2/components/Icon.vue';
import { hasPressedCommandAndEnter } from 'shared/helpers/KeyboardHelpers';
export default {
  components: {
    WootMessageEditor,
    V2Icon,
  },

  data() {
    return {
      noteContent: '',
    };
  },

  computed: {
    buttonDisabled() {
      return this.noteContent === '';
    },
  },

  mounted() {
    document.addEventListener('keydown', this.onMetaEnter);
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.onMetaEnter);
  },

  methods: {
    onMetaEnter(e) {
      if (hasPressedCommandAndEnter(e)) {
        e.preventDefault();
        this.onAdd();
      }
    },
    onAdd() {
      if (this.noteContent !== '') {
        this.$emit('add', this.noteContent);
      }
      this.noteContent = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.input--note {
  &::v-deep .ProseMirror-menubar {
    @apply bg-transparent;
    padding: 0;
    margin-top: var(--space-minus-small);
  }

  &::v-deep .ProseMirror-woot-style {
    min-height: 18rem;
    max-height: 22.5rem;

    p {
      @apply text-base;
    }
  }
}
</style>
